import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Card, Col, Row, Table, Button, Input, Select, Space, Tag, Drawer, List, Avatar, Typography, message  } from 'antd';
import { SearchOutlined, ReloadOutlined, LogoutOutlined, FilterOutlined, UserOutlined, PhoneOutlined, EnvironmentOutlined, BarChartOutlined,DownloadOutlined } from '@ant-design/icons';
import moment from 'moment';
import * as XLSX from 'xlsx';
import './Dashboard.css';

const { Text, Title } = Typography;

const { Search } = Input;
const { Option } = Select;

const Dashboard = () => {
  const [data, setData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const [filterDrawerVisible, setFilterDrawerVisible] = useState(false);
  const [mobileCurrentPage, setMobileCurrentPage] = useState(1);
  const [mobilePageSize] = useState(10);
  const navigate = useNavigate();
  const [pageSize, setPageSize] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);


  // Filtreleme state'leri
  const [filters, setFilters] = useState({
    search: '',
    city: '',
    caravanType: '',
    caravanYear: '',
    language: ''
  });




const exportToExcel = () => {
    try {
      // Excel için veriyi hazırla
      const excelData = filteredData.map((item, index) => ({
        'Sıra No': index + 1,
        'Ad': item.NAME || '',
        'Soyad': item.SURNAME || '',
        'E-posta': item.USER_ID || '',
        'Telefon': item.PHONE_NUMBER || '',
        'Şehir': item.CITY || '',
        'Plaka': item.PLATE_NUMBER || '',
        'Karavan Tipi': item.CARAVAN_TYPE || '',
        'Karavan Modeli': item.CARAVAN_MODEL || '',
        'Karavan Yılı': item.CARAVAN_YEAR || '',
        'Son Giriş': item.USER_LAST_LOGIN ? moment.unix(item.USER_LAST_LOGIN).format('DD/MM/YYYY HH:mm') : '',
        'Kayıt Tarihi': item.USER_CREATED_DATE ? moment.unix(item.USER_CREATED_DATE).format('DD/MM/YYYY') : '',
        'Kullanılan Dil': item.USED_LANGUAGE || '',
      }));

      // Excel dosyası oluştur
      const ws = XLSX.utils.json_to_sheet(excelData);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "Kullanıcı Verileri");

      // Kolon genişlikleri ayarla
      const colWidths = [
        { wch: 8 },  // Sıra No
        { wch: 15 }, // Ad
        { wch: 15 }, // Soyad
        { wch: 25 }, // E-posta
        { wch: 15 }, // Telefon
        { wch: 15 }, // Şehir
        { wch: 12 }, // Plaka
        { wch: 15 }, // Karavan Tipi
        { wch: 20 }, // Karavan Modeli
        { wch: 10 }, // Karavan Yılı
        { wch: 15 }, // Karavan Markası
        { wch: 18 }, // Son Giriş
        { wch: 12 }, // Kayıt Tarihi
        { wch: 12 }, // Kullanılan Dil
        { wch: 12 }, // Reklam Kabul
        { wch: 15 }, // Üyelik Durumu
        { wch: 15 }, // Referans Kodu
        { wch: 12 }, // Pil Seviyesi
        { wch: 12 }, // Su Seviyesi
        { wch: 12 }, // Gri Su
        { wch: 12 }  // Siyah Su
      ];
      ws['!cols'] = colWidths;

      // Dosya adı oluştur (tarih ile)
      const fileName = `Octoopi_Kullanicilar_${moment().format('DD-MM-YYYY_HH-mm')}.xlsx`;
      
      // Dosyayı indir
      XLSX.writeFile(wb, fileName);
      
      message.success(`${filteredData.length} kayıt Excel dosyasına aktarıldı!`);
    } catch (error) {
      console.error('Excel export hatası:', error);
      message.error('Excel dosyası oluşturulurken hata oluştu!');
    }
  };

const normalizeCity = (city) => {
  if (!city) return '';
  return city
    .toLowerCase()
    .trim()
    .replace(/ı/g, 'i')
    .replace(/ğ/g, 'g')
    .replace(/ü/g, 'u')
    .replace(/ş/g, 's')
    .replace(/ç/g, 'c')
    .replace(/ö/g, 'o')
    .replace(/i̇/g, 'i');
};



  // API'den veri çekme
  const fetchData = async () => {
    setLoading(true);
    try {
      const token = sessionStorage.getItem('token');
      const response = await fetch("https://wfh4zanzfa.execute-api.eu-central-1.amazonaws.com/api1/analytics", {
        method: 'GET',
        headers: {
          'Authorization': `Basic ${token}`,
        },
      });

      if (response.ok) {
  const result = await response.json();
  const sorted = [...result].sort((a, b) => (b.USER_CREATED_DATE || 0) - (a.USER_CREATED_DATE || 0));
  setData(sorted);
  setFilteredData(sorted);
} else {
        console.error('Veri çekilemedi');
      }
    } catch (error) {
      console.error('API Hatası:', error);
    }
    setLoading(false);
  };

  // Ekran boyutunu kontrol et
  useEffect(() => {
    const checkScreenSize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    checkScreenSize();
    window.addEventListener('resize', checkScreenSize);

    return () => window.removeEventListener('resize', checkScreenSize);
  }, []);

  useEffect(() => {
    fetchData();
  }, []);

  // Filtreleme fonksiyonu
  useEffect(() => {
    let filtered = data;

    // Genel arama
    if (filters.search) {
      filtered = filtered.filter(item => 
        Object.values(item).some(value => 
          value && value.toString().toLowerCase().includes(filters.search.toLowerCase())
        )
      );
    }

// Şehir filtresi
if (filters.city) {
  filtered = filtered.filter(item => normalizeCity(item.CITY) === normalizeCity(filters.city));
}

    // Karavan tipi filtresi
    if (filters.caravanType) {
      filtered = filtered.filter(item => item.CARAVAN_TYPE === filters.caravanType);
    }

    // Karavan yılı filtresi
    if (filters.caravanYear) {
      filtered = filtered.filter(item => item.CARAVAN_YEAR === filters.caravanYear);
    }

    // Dil filtresi
    if (filters.language) {
      filtered = filtered.filter(item => item.USED_LANGUAGE === filters.language);
    }

    setFilteredData(filtered);
    setMobileCurrentPage(1); // Filtre değiştiğinde sayfa resetle
    setCurrentPage(1);
  }, [data, filters]);

  // Benzersiz değerleri alma
// Benzersiz değerleri alma
const getUniqueValues = (field) => {
  if (field === 'CITY') {
    // Şehirler için özel normalize işlemi
    return data.reduce((acc, item) => {
      if (item[field]) {
        const normalizedCity = normalizeCity(item[field]);
        if (!acc.find(city => normalizeCity(city) === normalizedCity)) {
          acc.push(item[field]);
        }
      }
      return acc;
    }, []).sort();
  }
  return [...new Set(data.map(item => item[field]).filter(Boolean))].sort();
};
  // CITY için özel fonksiyon

  // Son giriş tarihini formatla
  const formatDate = (timestamp) => {
    if (!timestamp) return 'Bilinmiyor';
    return moment.unix(timestamp).format('DD/MM/YYYY HH:mm');
  };

  // Kayıt tarihini formatla
  const formatCreatedDate = (timestamp) => {
    if (!timestamp) return 'Bilinmiyor';
    return moment.unix(timestamp).format('DD/MM/YYYY');
  };

  // Mobile için basitleştirilmiş kolonlar
  const mobileColumns = [
    {
      title: 'Kullanıcı Bilgileri',
      key: 'userInfo',
      render: (record) => (
        <div>
          <div style={{ fontWeight: 'bold', marginBottom: '4px' }}>
            {`${record.NAME || ''} ${record.SURNAME || ''}`.trim()}
          </div>
          <div style={{ fontSize: '12px', color: '#666' }}>
            {record.USER_ID}
          </div>
          {record.PHONE_NUMBER && (
            <div style={{ fontSize: '12px', color: '#666' }}>
              📞 {record.PHONE_NUMBER}
            </div>
          )}
          <div style={{ marginTop: '4px' }}>
            {record.CITY && <Tag color="blue" size="small">{record.CITY}</Tag>}
            {record.CARAVAN_TYPE && <Tag color="green" size="small">{record.CARAVAN_TYPE}</Tag>}
          </div>
        </div>
      ),
    },
  ];

  // Desktop için detaylı kolonlar
  // Desktop için detaylı kolonlar
  const desktopColumns = [
    {
      title: 'Ad Soyad',
      key: 'fullName',
      render: (record) => `${record.NAME || ''} ${record.SURNAME || ''}`.trim(),
      sorter: (a, b) => (`${a.NAME || ''} ${a.SURNAME || ''}`).localeCompare(`${b.NAME || ''} ${b.SURNAME || ''}`),
    },
    {
      title: 'E-posta',
      dataIndex: 'USER_ID',
      key: 'USER_ID',
      sorter: (a, b) => (a.USER_ID || '').localeCompare(b.USER_ID || ''),
    },
    {
      title: 'Telefon',
      dataIndex: 'PHONE_NUMBER',
      key: 'PHONE_NUMBER',
      render: (phone) => phone || 'Belirtilmemiş',
    },
    {
      title: 'Şehir',
      dataIndex: 'CITY',
      key: 'CITY',
      render: (city) => city ? <Tag color="blue">{city}</Tag> : 'Belirtilmemiş',
      sorter: (a, b) => (a.CITY || '').localeCompare(b.CITY || ''),
    },
    {
      title: 'Plaka',
      dataIndex: 'PLATE_NUMBER',
      key: 'PLATE_NUMBER',
      render: (plate) => plate || 'Belirtilmemiş',
    },
    {
      title: 'Karavan Tipi',
      dataIndex: 'CARAVAN_TYPE',
      key: 'CARAVAN_TYPE',
      render: (type) => {
        if (!type) return 'Belirtilmemiş';
        const colors = {
          'motocaravan': 'green',
          'trailer': 'orange',
          'camper': 'purple'
        };
        return <Tag color={colors[type] || 'default'}>{type}</Tag>;
      },
      sorter: (a, b) => (a.CARAVAN_TYPE || '').localeCompare(b.CARAVAN_TYPE || ''),
    },
    {
      title: 'Karavan Modeli',
      dataIndex: 'CARAVAN_MODEL',
      key: 'CARAVAN_MODEL',
      render: (model) => model || 'Belirtilmemiş',
      sorter: (a, b) => (a.CARAVAN_MODEL || '').localeCompare(b.CARAVAN_MODEL || ''),
    },
    {
      title: 'Karavan Yılı',
      dataIndex: 'CARAVAN_YEAR',
      key: 'CARAVAN_YEAR',
      render: (year) => year || 'Belirtilmemiş',
      sorter: (a, b) => (a.CARAVAN_YEAR || 0) - (b.CARAVAN_YEAR || 0),
    },
    {
      title: 'Dil',
      dataIndex: 'USED_LANGUAGE',
      key: 'USED_LANGUAGE',
      render: (lang) => {
        if (!lang) return 'Belirtilmemiş';
        const langMap = {
          'TR': { name: 'Türkçe', color: 'red', flag: '🇹🇷' },
          'EN': { name: 'İngilizce', color: 'blue', flag: '🇬🇧' },
          'DE': { name: 'Almanca', color: 'orange', flag: '🇩🇪' }
        };
        const langInfo = langMap[lang] || { name: lang, color: 'default', flag: '' };
        return <Tag color={langInfo.color}>{langInfo.flag} {langInfo.name}</Tag>;
      },
      sorter: (a, b) => (a.USED_LANGUAGE || '').localeCompare(b.USED_LANGUAGE || ''),
    },
{
  title: 'Son Giriş',
  dataIndex: 'USER_LAST_LOGIN',  // DÜZELTİLDİ
  key: 'USER_LAST_LOGIN',
  render: formatDate,
  sorter: (a, b) => (a.USER_LAST_LOGIN || 0) - (b.USER_LAST_LOGIN || 0),
},
{
  title: 'Kayıt Tarihi',
  dataIndex: 'USER_CREATED_DATE',
  key: 'USER_CREATED_DATE',
  render: formatCreatedDate,
  sorter: (a, b) => (a.USER_CREATED_DATE || 0) - (b.USER_CREATED_DATE || 0),
  defaultSortOrder: 'descend',  // ← bunu ekle
},

  ];

  // Filtreleri temizle
  const clearFilters = () => {
    setFilters({
      search: '',
      city: '',
      caravanType: '',
      caravanYear: '',
      language: ''
    });
  };

  // Aktif filtre sayısını hesapla
  const getActiveFiltersCount = () => {
    return Object.values(filters).filter(value => value !== '').length;
  };

  // Aktif filtreleri metinsel olarak göster
  const getActiveFiltersText = () => {
    const activeFilters = [];
    if (filters.search) activeFilters.push(`Arama: ${filters.search}`);
    if (filters.city) activeFilters.push(`Şehir: ${filters.city}`);
    if (filters.caravanType) activeFilters.push(`Karavan Tipi: ${filters.caravanType}`);
    if (filters.caravanYear) activeFilters.push(`Karavan Yılı: ${filters.caravanYear}`);
    if (filters.language) {
      const langMap = { 'TR': 'Türkçe', 'EN': 'İngilizce', 'DE': 'Almanca' };
      activeFilters.push(`Dil: ${langMap[filters.language] || filters.language}`);
    }
    return activeFilters;
  };

  // Mobile kullanıcı kartı
  const MobileUserCard = ({ user }) => (
    <Card 
      size="small" 
      style={{ 
        marginBottom: '12px',
        borderRadius: '8px',
        boxShadow: '0 1px 3px rgba(0,0,0,0.12)'
      }}
    >
      <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '12px' }}>
        <div style={{ flex: 1 }}>
          <div style={{ display: 'flex', alignItems: 'center', marginBottom: '8px' }}>
            <Avatar icon={<UserOutlined />} size="small" style={{ marginRight: '8px' }} />
            <div>
              <Text strong style={{ display: 'block', fontSize: '14px' }}>
                {`${user.NAME || ''} ${user.SURNAME || ''}`.trim() || 'İsimsiz Kullanıcı'}
              </Text>
              <Text type="secondary" style={{ fontSize: '11px' }}>
                {user.USER_ID}
              </Text>
            </div>
          </div>

          <Space size={[4, 4]} wrap style={{ marginTop: '8px' }}>
            {user.PHONE_NUMBER && (
              <Tag icon={<PhoneOutlined />} color="default" style={{ fontSize: '11px' }}>
                {user.PHONE_NUMBER}
              </Tag>
            )}
            {user.CITY && (
              <Tag icon={<EnvironmentOutlined />} color="blue" style={{ fontSize: '11px' }}>
                {user.CITY}
              </Tag>
            )}
            {user.PLATE_NUMBER && (
              <Tag color="orange" style={{ fontSize: '11px' }}>
                {user.PLATE_NUMBER}
              </Tag>
            )}
          </Space>
        </div>
      </div>

      <div style={{ 
        borderTop: '1px solid #f0f0f0', 
        paddingTop: '12px',
        display: 'grid',
        gridTemplateColumns: '1fr 1fr',
        gap: '8px'
      }}>
        <div>
          <Text type="secondary" style={{ fontSize: '10px', display: 'block' }}>Karavan Tipi</Text>
          <Text style={{ fontSize: '12px' }}>{user.CARAVAN_TYPE || 'Belirtilmemiş'}</Text>
        </div>
        <div>
          <Text type="secondary" style={{ fontSize: '10px', display: 'block' }}>Model</Text>
          <Text style={{ fontSize: '12px' }}>{user.CARAVAN_MODEL || 'Belirtilmemiş'}</Text>
        </div>
        <div>
          <Text type="secondary" style={{ fontSize: '10px', display: 'block' }}>Yıl</Text>
          <Text style={{ fontSize: '12px' }}>{user.CARAVAN_YEAR || 'Belirtilmemiş'}</Text>
        </div>
        <div>
          <Text type="secondary" style={{ fontSize: '10px', display: 'block' }}>Dil</Text>
          <Text style={{ fontSize: '12px' }}>
            {user.USED_LANGUAGE === 'TR' ? '🇹🇷 Türkçe' : 
             user.USED_LANGUAGE === 'EN' ? '🇬🇧 İngilizce' :
             user.USED_LANGUAGE === 'DE' ? '🇩🇪 Almanca' : 
             user.USED_LANGUAGE || 'Belirtilmemiş'}
          </Text>
        </div>
      </div>

      <div style={{ 
        borderTop: '1px solid #f0f0f0', 
        marginTop: '12px',
        paddingTop: '8px',
        display: 'flex',
        justifyContent: 'space-between',
        fontSize: '10px'
      }}>
        <Text type="secondary">
          <span>Son Giriş: </span>
          <Text style={{ fontSize: '10px' }}>{formatDate(user.USER_LAST_LOGIN)}</Text>
        </Text>
        <Text type="secondary">
          <span>Kayıt: </span>
          <Text style={{ fontSize: '10px' }}>{formatCreatedDate(user.USER_CREATED_DATE)}</Text>
        </Text>
      </div>
    </Card>
  );

  // Mobil filtre drawer
  const FilterDrawer = () => (
    <Drawer
      title="Filtrele"
      placement="bottom"
      onClose={() => setFilterDrawerVisible(false)}
      open={filterDrawerVisible}
      height="80%"
      bodyStyle={{ paddingTop: 0 }}
      extra={
        <Button size="small" type="link" onClick={clearFilters}>
          Temizle
        </Button>
      }
    >
      <List>
        <List.Item>
          <div style={{ width: '100%' }}>
            <Text type="secondary" style={{ fontSize: '12px', marginBottom: '4px', display: 'block' }}>
              Genel Arama (Ad, E-posta, Plaka vb.)
            </Text>
            <Input
              placeholder="Ara..."
              value={filters.search}
              onChange={(e) => setFilters(prev => ({ ...prev, search: e.target.value }))}
              prefix={<SearchOutlined />}
            />
          </div>
        </List.Item>

        <List.Item>
          <div style={{ width: '100%' }}>
            <Text type="secondary" style={{ fontSize: '12px', marginBottom: '4px', display: 'block' }}>
              Şehir Filtresi
            </Text>
            <Select
              placeholder="Şehir Seçin"
              value={filters.city}
              onChange={(value) => setFilters(prev => ({ ...prev, city: value }))}
              style={{ width: '100%' }}
              allowClear
            >
              {getUniqueValues('CITY').map(city => (
                <Option key={city} value={city}>{city}</Option>
              ))}
            </Select>
          </div>
        </List.Item>

        <List.Item>
          <div style={{ width: '100%' }}>
            <Text type="secondary" style={{ fontSize: '12px', marginBottom: '4px', display: 'block' }}>
              Karavan Tipi Filtresi
            </Text>
            <Select
              placeholder="Karavan Tipi Seçin"
              value={filters.caravanType}
              onChange={(value) => setFilters(prev => ({ ...prev, caravanType: value }))}
              style={{ width: '100%' }}
              allowClear
            >
              {getUniqueValues('CARAVAN_TYPE').map(type => (
                <Option key={type} value={type}>{type}</Option>
              ))}
            </Select>
          </div>
        </List.Item>

        <List.Item>
          <div style={{ width: '100%' }}>
            <Text type="secondary" style={{ fontSize: '12px', marginBottom: '4px', display: 'block' }}>
              Karavan Yılı Filtresi
            </Text>
            <Select
              placeholder="Yıl Seçin"
              value={filters.caravanYear}
              onChange={(value) => setFilters(prev => ({ ...prev, caravanYear: value }))}
              style={{ width: '100%' }}
              allowClear
            >
              {getUniqueValues('CARAVAN_YEAR').map(year => (
                <Option key={year} value={year}>{year}</Option>
              ))}
            </Select>
          </div>
        </List.Item>

        <List.Item>
          <div style={{ width: '100%' }}>
            <Text type="secondary" style={{ fontSize: '12px', marginBottom: '4px', display: 'block' }}>
              Dil Filtresi
            </Text>
            <Select
              placeholder="Dil Seçin"
              value={filters.language}
              onChange={(value) => setFilters(prev => ({ ...prev, language: value }))}
              style={{ width: '100%' }}
              allowClear
            >
              {getUniqueValues('USED_LANGUAGE').map(lang => (
                <Option key={lang} value={lang}>
                  {lang === 'TR' ? '🇹🇷 Türkçe' : 
                   lang === 'EN' ? '🇬🇧 İngilizce' : 
                   lang === 'DE' ? '🇩🇪 Almanca' : lang}
                </Option>
              ))}
            </Select>
          </div>
        </List.Item>
      </List>
    </Drawer>
  );

  return (
    <div style={{ padding: '24px', backgroundColor: '#f0f2f5', minHeight: '100vh' }}>
      <Row gutter={[24, 24]}>
        <Col span={24}>
          <Card bordered={false}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
              <Title level={isMobile ? 4 : 2}>
                <UserOutlined style={{ marginRight: '8px' }} />
                Kullanıcı Yönetimi
              </Title>
              <Space>
                <Button 
                  type="primary" 
                  icon={<DownloadOutlined />} 
                  onClick={exportToExcel}
                  loading={loading}
                  style={{ backgroundColor: '#52c41a', borderColor: '#52c41a' }}
                >
                  Excel Al ({filteredData.length})
                </Button>
                <Button
                  type="primary"
                  icon={<BarChartOutlined />}
                  onClick={() => navigate('/total')}
                  style={{ backgroundColor: '#52c41a', borderColor: '#52c41a' }}
                >
                  {isMobile ? 'İstatistikler' : 'İstatistikleri Görüntüle'}
                </Button>
                <Button
                  icon={<ReloadOutlined />}
                  onClick={fetchData}
                  loading={loading}
                  title="Verileri Yenile"
                >
                  {!isMobile && 'Yenile'}
                </Button>
                {isMobile && (
                  <Button
                    icon={<FilterOutlined />}
                    onClick={() => setFilterDrawerVisible(true)}
                    type={getActiveFiltersCount() > 0 ? 'primary' : 'default'}
                  >
                    {getActiveFiltersCount() > 0 && `(${getActiveFiltersCount()})`}
                  </Button>
                )}
                <Button
                  icon={<LogoutOutlined />}
                  onClick={() => {
                    sessionStorage.removeItem('token');
                    navigate('/');
                  }}
                  danger
                  title="Çıkış Yap"
                >
                  {!isMobile && 'Çıkış'}
                </Button>
              </Space>
            </div>

            {/* Desktop filtreleri */}
            {!isMobile && (
              <>
                {/* Aktif filtreler göstergesi */}
                {getActiveFiltersCount() > 0 && (
                  <Card size="small" style={{ marginBottom: '16px', backgroundColor: '#e6f7ff', borderColor: '#1890ff' }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                      <div>
                        <Text strong style={{ color: '#1890ff', marginRight: '16px' }}>
                          Aktif Filtreler ({getActiveFiltersCount()}):
                        </Text>
                        {getActiveFiltersText().map((filter, index) => (
                          <Tag key={index} color="blue" style={{ marginRight: '8px' }}>
                            {filter}
                          </Tag>
                        ))}
                      </div>
                      <Button size="small" onClick={clearFilters}>
                        Filtreleri Temizle
                      </Button>
                    </div>
                  </Card>
                )}

                <Card size="small" style={{ marginBottom: '20px', backgroundColor: '#fafafa' }}>
                  <Row gutter={[16, 16]}>
                    <Col xs={24} sm={12} md={8}>
                      <div>
                        <Text type="secondary" style={{ fontSize: '12px', marginBottom: '4px', display: 'block' }}>
                          Genel Arama
                        </Text>
                        <Input
                          placeholder="Ad, E-posta, Plaka, Telefon vb. ara..."
                          value={filters.search}
                          onChange={(e) => setFilters(prev => ({ ...prev, search: e.target.value }))}
                          style={{ width: '100%' }}
                          prefix={<SearchOutlined />}
                        />
                      </div>
                    </Col>
                    <Col xs={12} sm={6} md={4}>
                      <div>
                        <Text type="secondary" style={{ fontSize: '12px', marginBottom: '4px', display: 'block' }}>
                          Şehir Filtresi
                        </Text>
                        <Select
                          placeholder="Şehir Seçin"
                          value={filters.city}
                          onChange={(value) => setFilters(prev => ({ ...prev, city: value }))}
                          style={{ width: '100%' }}
                          allowClear
                        >
                          {getUniqueValues('CITY').map(city => (
                            <Option key={city} value={city}>{city}</Option>
                          ))}
                        </Select>
                      </div>
                    </Col>
                    <Col xs={12} sm={6} md={4}>
                      <div>
                        <Text type="secondary" style={{ fontSize: '12px', marginBottom: '4px', display: 'block' }}>
                          Karavan Tipi
                        </Text>
                        <Select
                          placeholder="Tip Seçin"
                          value={filters.caravanType}
                          onChange={(value) => setFilters(prev => ({ ...prev, caravanType: value }))}
                          style={{ width: '100%' }}
                          allowClear
                        >
                          {getUniqueValues('CARAVAN_TYPE').map(type => (
                            <Option key={type} value={type}>{type}</Option>
                          ))}
                        </Select>
                      </div>
                    </Col>
                    <Col xs={12} sm={6} md={4}>
                      <div>
                        <Text type="secondary" style={{ fontSize: '12px', marginBottom: '4px', display: 'block' }}>
                          Karavan Yılı
                        </Text>
                        <Select
                          placeholder="Yıl Seçin"
                          value={filters.caravanYear}
                          onChange={(value) => setFilters(prev => ({ ...prev, caravanYear: value }))}
                          style={{ width: '100%' }}
                          allowClear
                        >
                          {getUniqueValues('CARAVAN_YEAR').map(year => (
                            <Option key={year} value={year}>{year}</Option>
                          ))}
                        </Select>
                      </div>
                    </Col>
                    <Col xs={12} sm={6} md={4}>
                      <div>
                        <Text type="secondary" style={{ fontSize: '12px', marginBottom: '4px', display: 'block' }}>
                          Dil Seçimi
                        </Text>
                        <Select
                          placeholder="Dil Seçin"
                          value={filters.language}
                          onChange={(value) => setFilters(prev => ({ ...prev, language: value }))}
                          style={{ width: '100%' }}
                          allowClear
                        >
                          {getUniqueValues('USED_LANGUAGE').map(lang => (
                            <Option key={lang} value={lang}>
                              {lang === 'TR' ? '🇹🇷 Türkçe' : 
                               lang === 'EN' ? '🇬🇧 İngilizce' : 
                               lang === 'DE' ? '🇩🇪 Almanca' : lang}
                            </Option>
                          ))}
                        </Select>
                      </div>
                    </Col>
                  </Row>
                </Card>
              </>
            )}

            {/* Mobile için kart listesi */}
            {isMobile ? (
              <div>
                {/* Aktif filtreler göstergesi */}
                {getActiveFiltersCount() > 0 && (
                  <Card size="small" style={{ marginBottom: '16px', backgroundColor: '#e6f7ff', borderColor: '#1890ff' }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                      <div>
                        <Text strong style={{ color: '#1890ff', fontSize: '12px' }}>
                          Aktif Filtreler ({getActiveFiltersCount()}):
                        </Text>
                        <div style={{ marginTop: '4px' }}>
                          {getActiveFiltersText().map((filter, index) => (
                            <Tag key={index} color="blue" size="small" style={{ marginBottom: '2px' }}>
                              {filter}
                            </Tag>
                          ))}
                        </div>
                      </div>
                      <Button size="small" type="link" onClick={clearFilters} style={{ padding: '0' }}>
                        Temizle
                      </Button>
                    </div>
                  </Card>
                )}

                {loading ? (
                  <div style={{ textAlign: 'center', padding: '40px' }}>
                    <Text>Yükleniyor...</Text>
                  </div>
                ) : (
                  <div>
                    {/* Pagination için veri hesaplama */}
                    {(() => {
                      const startIndex = (mobileCurrentPage - 1) * mobilePageSize;
                      const endIndex = startIndex + mobilePageSize;
                      const paginatedData = filteredData.slice(startIndex, endIndex);
                      const totalPages = Math.ceil(filteredData.length / mobilePageSize);

                      return (
                        <>
                          {/* Sayfa bilgisi */}
                          <div style={{ 
                            textAlign: 'center', 
                            marginBottom: '12px', 
                            padding: '8px',
                            backgroundColor: '#fafafa',
                            borderRadius: '6px',
                            fontSize: '12px'
                          }}>
                            <Text type="secondary">
                              Sayfa {mobileCurrentPage} / {totalPages || 1} - 
                              Toplam {filteredData.length} kayıt
                            </Text>
                          </div>

                          {/* Kullanıcı kartları */}
                          {paginatedData.map((user, index) => (
                            <MobileUserCard key={user.USER_ID || index} user={user} />
                          ))}

                          {/* Pagination butonları */}
                          {totalPages > 1 && (
                            <div style={{ 
                              display: 'flex', 
                              justifyContent: 'center', 
                              alignItems: 'center',
                              marginTop: '16px',
                              gap: '8px'
                            }}>
                              <Button 
                                size="small" 
                                onClick={() => setMobileCurrentPage(prev => Math.max(1, prev - 1))}
                                disabled={mobileCurrentPage === 1}
                              >
                                ← Önceki
                              </Button>
                              
                              <Text style={{ fontSize: '12px', margin: '0 8px' }}>
                                {mobileCurrentPage} / {totalPages}
                              </Text>
                              
                              <Button 
                                size="small"
                                onClick={() => setMobileCurrentPage(prev => Math.min(totalPages, prev + 1))}
                                disabled={mobileCurrentPage === totalPages}
                              >
                                Sonraki →
                              </Button>
                            </div>
                          )}

                          {filteredData.length === 0 && (
                            <div style={{ textAlign: 'center', padding: '40px' }}>
                              <Text type="secondary">
                                {getActiveFiltersCount() > 0 ? 'Filtrelere uygun kullanıcı bulunamadı' : 'Kullanıcı bulunamadı'}
                              </Text>
                            </div>
                          )}
                        </>
                      );
                    })()}
                  </div>
                )}
              </div>
            ) : (
              /* Desktop için tablo */
              <Table
    dataSource={filteredData}
    columns={desktopColumns}
    rowKey="USER_ID"
    loading={loading}
    pagination={{
      current: currentPage,
      pageSize,
      onChange: (page, newSize) => {
        setCurrentPage(page);
        if (newSize !== pageSize) setPageSize(newSize);
      },
      showSizeChanger: true,
      showQuickJumper: true,
      showTotal: (total, range) => `${range[0]}-${range[1]} / ${total} kayıt`,
      pageSizeOptions: [5, 10, 20, 50]
    }}
    scroll={{ x: 1200 }}
    bordered
    size="small"
  />
            )}

            {/* Mobile filtre drawer */}
            {isMobile && <FilterDrawer />}
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default Dashboard;